export class ProductConstant {
  static readonly Messages = {
    ProductPriceEffectiveMessage:
      '<h6><p>Effective February 7, 2017 ' +
      'all pricing reflected on parmed.com is based upon your 60 day price history ' +
      'unless there has been a price increase directly on the product.</p></h6>',
    NoSearchResultFoundMessage:
      'We did not come up with any products that matched your search. Please retry your search using a different' +
      ' criteria. If you still are not able to find the product you are looking for, please contact your Sales' +
      ' Representative at',
    NoSubscriptionSearchResultFoundMessage: 'We did not come up with any products that matched your search. ' +
    'Please retry your search using a different criteria. Click on the Full Subscription List button to view the complete list',
    NoHistoryFoundMessage: 'No purchase history details available.',
    NoHistoryFoundMessageMobile: 'You have not purchased this item recently.',
    GetHistoryErrorMessage:
      'An error has occurred while getting history details.',
    WaitForSubstitutes:
     'Please wait while loading the data.',  
    NoSubsFoundMessage:
      'No substitutes are available for this item.',
    NoPrebookFoundMessage: 'No prebook product details available.',
    SendPrebookSuccessMessage:
      'Your prebook order has been processed. The products are not yet in stock. ' +
      'Your order will be released as soon as the item is available in the market',
    SendPrebookErrorMessage:
      'Error occurred while processing prebook order. Please try after sometime.',
    ProductAvailabilityMessage: {
      NotAvailable: 'The item is no longer available.',
      OutofStock: 'The item is temporarily out of stock.'
    },
    WatchListPageHeader: 
      '<h6><p> You will receive an email notification ' + 
      'when items on the Watchlist are available for purchase. ' +
      'To stop email notifications, please remove the product from your Watchlist. ' + 
      'Items added to the Watchlist will expire after six months, to continue receiving email notifications ' + 
      'for these items, please add them again.</p></h6>'
    
  };
}
